import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-167">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="prose prose-invert prose-lg mx-auto" data-id="element-168">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-8 uppercase" data-id="element-169">
          Ahora hablemos claro.
        </h2>

        <p className="text-xl text-zinc-300 mb-6 font-medium" data-id="element-170">
          Si sos barbero, esto te va a sonar:
        </p>

        <div className="bg-zinc-900/50 border-l-4 border-zinc-700 p-6 mb-10 rounded-r-xl" data-id="element-171">
          <p className="mb-2 text-zinc-400" data-id="element-172">
            Martes: <span className="text-white" data-id="element-173">uno o ningún turno.</span>
          </p>
          <p className="mb-2 text-zinc-400" data-id="element-174">
            Miércoles: <span className="text-white" data-id="element-175">medio flojo.</span>
          </p>
          <p className="mb-4 text-zinc-400" data-id="element-176">
            Jueves <span className="text-white" data-id="element-177">recién arranca.</span>
          </p>

          <p className="mb-4 text-amber-500 font-bold" data-id="element-178">Y después…</p>

          <p className="mb-2 text-zinc-300" data-id="element-179">
            Viernes <span className="text-white font-bold" data-id="element-180">explotado.</span>
          </p>
          <p className="mb-2 text-zinc-300" data-id="element-181">
            Sábado <span className="text-white font-bold" data-id="element-182">una locura.</span>
          </p>
          <p className="mb-2 text-zinc-300" data-id="element-183">
            12 horas <span className="text-white font-bold" data-id="element-184">parado.</span>
          </p>
          <p className="mb-2 text-zinc-300" data-id="element-185">
            Espalda <span className="text-white font-bold" data-id="element-186">rota.</span>
          </p>
          <p className="mb-0 text-zinc-300" data-id="element-187">
            Cero energía cuando llegás a tu casa.
          </p>
        </div>

        <p className="text-xl text-zinc-300 mb-12 font-medium" data-id="element-188">
          Y aun así no sabés cuánto vas a ganar el mes que viene.
        </p>

        <div className="mb-16" data-id="element-189">
          <h3 className="text-2xl font-heading font-bold text-amber-500 mb-4 uppercase" data-id="element-190">
            Ese es el problema.
          </h3>
          <p className="text-2xl text-white font-bold mb-2" data-id="element-191">
            No es que trabajás poco.
          </p>
          <p className="text-2xl text-white font-bold" data-id="element-192">
            Es que trabajás sin plan.
          </p>
        </div>

        <div className="mb-16" data-id="element-193">
          <h3 className="text-3xl font-heading font-bold text-white mb-6 uppercase border-b border-zinc-800 pb-4" data-id="element-194">
            El ciclo que te está quemando
          </h3>
          <ul className="space-y-4 text-lg text-zinc-300 list-none pl-0" data-id="element-195">
            <li className="flex items-center gap-3" data-id="element-196">
              <span className="text-amber-500" data-id="element-197">🔥</span> Esperar que entren
              mensajes.
            </li>
            <li className="flex items-center gap-3" data-id="element-198">
              <span className="text-amber-500" data-id="element-199">🔥</span> Rezar para que el
              sábado se llene.
            </li>
            <li className="flex items-center gap-3" data-id="element-200">
              <span className="text-amber-500" data-id="element-201">🔥</span> Aceptar cancelaciones
              sobre la hora.
            </li>
            <li className="flex items-center gap-3" data-id="element-202">
              <span className="text-amber-500" data-id="element-203">🔥</span> Meter más turnos para
              “aprovechar”.
            </li>
          </ul>
          <div className="mt-8 p-6 bg-amber-500/10 border border-amber-500/20 rounded-xl" data-id="element-204">
            <p className="text-xl text-white font-bold mb-2" data-id="element-205">
              Trabajás más para compensar el desorden.
            </p>
            <p className="text-xl text-amber-400 font-bold" data-id="element-206">
              Y el desorden sigue.
            </p>
          </div>
        </div>

        <div data-id="element-207">
          <h3 className="text-3xl font-heading font-bold text-white mb-6 uppercase border-b border-zinc-800 pb-4" data-id="element-208">
            La verdad incómoda
          </h3>
          <p className="text-xl text-zinc-400 mb-2" data-id="element-209">No es la competencia.</p>
          <p className="text-xl text-zinc-400 mb-6" data-id="element-210">No es la crisis.</p>

          <p className="text-2xl text-white font-bold mb-6" data-id="element-211">
            Es que cada cliente viene, paga y se va.
          </p>

          <div className="space-y-2 text-lg text-zinc-300 mb-8 font-medium" data-id="element-212">
            <p className="flex items-center gap-2" data-id="element-213">
              <span className="w-2 h-2 bg-red-500 rounded-full" data-id="element-214"></span> Sin
              próxima fecha.
            </p>
            <p className="flex items-center gap-2" data-id="element-215">
              <span className="w-2 h-2 bg-red-500 rounded-full" data-id="element-216"></span> Sin
              estructura.
            </p>
            <p className="flex items-center gap-2" data-id="element-217">
              <span className="w-2 h-2 bg-red-500 rounded-full" data-id="element-218"></span> Sin
              previsión.
            </p>
          </div>

          <p className="text-2xl font-heading font-bold text-amber-500 uppercase tracking-wide bg-zinc-900 p-6 rounded-xl text-center border border-zinc-800" data-id="element-219">
            Así cualquier agenda se vuelve un caos.
          </p>
        </div>
      </motion.div>
    </section>;
}